package pl.mothdigital.neuronowi.common.utils

/**
 * Utility extension to fix Polish "orphans" (single letter words at the end of lines).
 * Replaces spaces after single-letter words with non-breaking spaces (\u00A0).
 */
fun String.fixPolishOrphans(): String {
    val singleLetters = "[aiouwzAIOWUZ]"
    return this
        .replace(Regex("(?<=\\s)($singleLetters)\\s+"), "$1\u00A0")
        .replace(Regex("^($singleLetters)\\s+"), "$1\u00A0")
}
